"use client";

import { useAuthStore } from "@/app/store/use-auth-store";
import { useCartStore } from "@/entities/cart/model/use-cart-store";
import { usePlatformStore } from "@/entities/platform";
import { IUser } from "@/features/auth/model/types";
import EditUserData from "@/features/profile/edit/ui/edit-form-model";
import ConfirmModal from "@/widgets/confirm-modal";
import { Flex, Heading, IconButton, Text } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { useState } from "react";
import LogoutIcon from "../assets/logout";
import PencilIcon from "../assets/pecil";

type Props = {
  user: IUser | null;
};

const UserDetails: React.FC<Props> = ({ user }) => {
  const { isPorte } = usePlatformStore();
  const { logOut } = useAuthStore();
  const { CLEAR } = useCartStore();
  const t = useTranslations();

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);

  const logoutUser = () => {
    logOut();
    CLEAR();
  };

  return (
    <Flex p="4" justifyContent="space-between" alignItems="center">
      <Flex direction="column">
        <Heading fontSize="lg">{user?.name}</Heading>
        <Text color="gray.600" fontSize="sm">
          {user?.phone || user?.email}
        </Text>
      </Flex>

      <Flex>
        <IconButton variant="ghost" onClick={() => setIsOpenModal(true)}>
          <PencilIcon color="var(--text-muted)" />
        </IconButton>

        {!isPorte && (
          <IconButton
            variant="ghost"
            onClick={() => setShowLogoutConfirmation(true)}
          >
            <LogoutIcon color="var(--text-muted)" />
          </IconButton>
        )}
      </Flex>

      <EditUserData isOpen={isOpenModal} setIsOpen={setIsOpenModal} />
      <ConfirmModal
        title={t("profile.logout")}
        description={t("profile.sure_logout")}
        isOpen={showLogoutConfirmation}
        onClose={() => setShowLogoutConfirmation(false)}
        onConfirm={logoutUser}
        text={{ confirm: "yes", cancel: "no" }}
      />
    </Flex>
  );
};

export default UserDetails;
